import { motion } from "framer-motion";
import { GAME_CATEGORIES } from "@/data/games";

const marqueeItems = [
  "CS2",
  "VALORANT",
  "LOL",
  "DOTA 2",
  "APEX",
  "WARZONE",
  "GTA V",
  "MINECRAFT",
  "OVERWATCH 2",
  "PUBG",
  "ROCKET LEAGUE",
  "WOW",
  "DIABLO IV",
  "RUST",
  "FORZA HORIZON 5",
];

export const Games = () => {
  return (
    <section
      id="games"
      data-testid="games-section"
      className="relative py-24 md:py-32 bg-[#0A0A0A] border-t border-zinc-900"
    >
      {/* Marquee */}
      <div className="relative overflow-hidden border-y border-zinc-900 py-4 mb-20 bg-black">
        <div className="flex marquee-track whitespace-nowrap gap-12">
          {[...marqueeItems, ...marqueeItems].map((g, i) => (
            <span
              key={i}
              className="font-display text-3xl md:text-5xl uppercase text-zinc-800 tracking-tighter"
            >
              {g}
              <span className="text-sky-400 ml-12">✦</span>
            </span>
          ))}
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <span className="h-px w-10 bg-sky-400" />
              <span className="font-mono text-[11px] tracking-[0.3em] text-sky-400 uppercase">
                The Library / 40+ Titles
              </span>
            </div>
            <h2 className="font-display text-white text-4xl md:text-5xl lg:text-6xl uppercase leading-[0.95]">
              Η λιστα των <span className="text-sky-400">games</span> μας
            </h2>
          </div>
          <p className="max-w-md text-zinc-400 text-sm md:text-base leading-relaxed">
            Από hardcore FPS τουρνουά μέχρι casual co-op βραδιές. Έχουμε το σωστό
            title για κάθε mood, και ready Steam accounts αν χρειαστείς.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          {GAME_CATEGORIES.map((cat, idx) => (
            <motion.div
              key={cat.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: idx * 0.1 }}
              data-testid={`game-category-${cat.id}`}
              className="relative border border-zinc-800 bg-zinc-950/60 p-6 md:p-8 hover:border-sky-400/50 transition-colors group"
            >
              <div className="absolute top-0 left-0 font-mono text-[10px] tracking-[0.3em] text-zinc-600 px-3 py-1 border-r border-b border-zinc-800">
                0{idx + 1} / 04
              </div>

              <div className="flex items-center gap-3 mt-6 mb-6">
                <cat.icon className={`w-6 h-6 ${cat.accent}`} />
                <div>
                  <h3 className="font-display text-white text-xl md:text-2xl uppercase leading-tight">
                    {cat.name}
                  </h3>
                  <p className="text-zinc-500 text-xs font-mono tracking-wider mt-0.5">
                    {cat.tagline}
                  </p>
                </div>
              </div>

              <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-2">
                {cat.games.map((g) => (
                  <li
                    key={g}
                    className="flex items-center gap-2 text-zinc-300 text-sm hover:text-sky-400 transition-colors"
                  >
                    <span className="text-sky-400/60 font-mono text-xs">▸</span>
                    <span>{g}</span>
                  </li>
                ))}
              </ul>

              <div className="absolute bottom-0 right-0 w-16 h-px bg-sky-400 opacity-0 group-hover:opacity-100 transition-opacity" />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
